import { JobGroup } from '@borg/types';

class ExclusiveJobsRepository extends Repository<JobGroup> {
  getMany() {
    return this._getMany({ url: `/jobs/exclusive`, cache: 'always', lazy: false });
  }
}

export const exclusiveJobsRepository = new ExclusiveJobsRepository();
